// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3JOn6","errorLogs":"styles_errorLogs__3s2Em"};